import React, { useState, useEffect, useLayoutEffect, useContext } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  Accordion,
  Form,
  Modal,
  Row,
  Col,
  useAccordionButton,
  Card,
  AccordionContext,
  Button
} from 'react-bootstrap'
import { useNavigate, Link } from 'react-router-dom'
import ApiPayment from '../../Config/ApiPayment'
import Api from '../../Config/Api'
import MasterApi from '../../Config/MasterApi'
import ProgressBar from '../../component/ProgressBar/progressbar'
import styles from './Pembayaran.module.css'
import Header from '../../component/Header/header'
import { sha3_256 } from 'js-sha3'
import Spinners from '../../component/Spinner/spinners'
import {
  updateStatusSpaj,
  updateStatusCustomer
} from '../../store/features/SPAJSlice'
import { formatCurrency, formatCurrencyNew, StatusCustomer } from '../../component/Helper'
import { isBrowser, isMobile } from 'react-device-detect'

import { checkValid } from '../../store/features/CameraAndSignatureSlice';
import LockScreen from '../../component/LockScreen/lockscreen';


const getOfflinePayment = async (SPAJs, SPAJDetail, DeviceId, setVaAccount,setVaAccountBni, setVaAccountBri,  setVaAccountMandiri) => {
  let data = {
    deviceId: DeviceId.deviceId,
    spajNumber: SPAJs.spajHeader.spajNumber,
    agentCode: SPAJDetail.dataPH.TCLN_AgentCode,
    isSyariah: SPAJs.spajHeader.isSyariah == 0 ? 0 : 1,
    // vaType: SPAJs.spajHeader.isSyariah == 0 ? 'SPAJ_OL' : 'SPAJ',
    // currency: 'IDR',
    //update for genwealth
    vaType: SPAJs.spajHeader.isSyariah == 0 ? SPAJDetail.dataFinancial.TRPH_PaymentCurr =='IDR' ? 'SPAJ_OL' : 'SPAJ' : 'SPAJ',
    currency: SPAJDetail.dataFinancial.TRPH_PaymentCurr,
    userName: SPAJs.spajHeader.userName
  }

  Api.post(Api.routeEapp+MasterApi.getOfflinePayment, data)
    .then(response => {      
      if(response.status == 'OK') {
        let dataVa = response.data.newVa

        for(let i = 0; i < dataVa.length; i++){
          console.log("dataVA",i,dataVa[i])
					if(dataVa[i].bankName === 'Permata')
					{
            setVaAccount(dataVa[i])
					}

          if(dataVa[i].bankName === 'BCA Dollar') // <--- update for genwealth
					{
						setVaAccount(dataVa[i])
					}
				
					if(dataVa[i].bankName === 'BCA Virtual Account Online')
					{
            setVaAccount(dataVa[i])
					}

					if(dataVa[i].bankName === 'BNI Virtual Account Online')
					{
            setVaAccountBni(dataVa[i])
					}

					if(dataVa[i].bankName === 'BRI Virtual Account Online')
					{
            setVaAccountBri(dataVa[i])
					}

					if(dataVa[i].bankName === 'Mandiri Virtual Account Online')
					{
            setVaAccountMandiri(dataVa[i])
					}
				}

      }
    })
    .catch(err => {
      return err
    })
}

const getPaymentData = async (
  SPAJs,
  SPAJDetail,
  DeviceId,
  setRbCaraBayar,
  setRbCaraBayar1,
  setPaymentData
) => {
  let tmpRequest = {
    spajNumber: SPAJs.spajHeader.spajNumber,
    agentCode: SPAJDetail.dataPH.TCLN_AgentCode,
    deviceId: DeviceId.deviceId,
    userName: SPAJs.spajHeader.userName
  }

  Api.post(Api.routeEapp+MasterApi.getPaymentData, tmpRequest)
    .then(resp => {
      if (resp.status == 'OK' ) {
        setRbCaraBayar(resp.data.paymentData.paymentType)
        setRbCaraBayar1(resp.data.paymentData.paymentMethod)
        setPaymentData(resp.data.paymentData)
      } else if (resp.httpStatus == 406){
      }
      else{
        sessionStorage.removeItem('tokenPayment')

      }
    })
    .catch(err => {
      return err
    })
}

const getTokenPayment = async (
  SPAJDetail,
  SPAJs,
  vaAccount,
  setUri,
  intervals,
  setIntervals,
  setRbCaraBayar,
  setRbCaraBayar1,
  setResponsePayment,
  setStatusPaymentOnline,
  setVisiblePopupPayment,
  setIsOpenGojek,
  isOpenGojek,
  setIsPayment,
  setisDonePay,
  vaAccountBni,
  vaAccountBri,
  vaAccountMandiri,
  setVaBank
) => {
  const getPaycode = SPAJDetail => {
    let isSTU =
        SPAJDetail.dataBenefitSpaj.transactionPlan.AmountTP != null
          ? true
          : false,
      dataFinancial = SPAJDetail.dataFinancial,
      paymentMedia = dataFinancial.TRPH_PaymentMethod,
      bankCode = dataFinancial.TRPD_BankCode,
      nominal =
        SPAJDetail.dataBenefitSpaj.basic.TotalPremium +
        (SPAJDetail.dataBenefitSpaj.transactionPlan.AmountTP || 0) + 
        (SPAJDetail.dataBenefitSpaj.basic.PolicyFee || 0),
      paycode = ''


      if (isSTU) {
        if (paymentMedia == 'C' || paymentMedia == 'D') paycode = 'YOU_NBSTU'
        else if (paymentMedia == 'N') paycode = 'YOU_SINGPAYSTU'
      } else {
        if (paymentMedia == 'C' || paymentMedia == 'D') {
          paycode = 'YOU_NB_Offline'
          if (nominal < 50000) paycode = 'YOU_NB_Offline50'
        } else if (paymentMedia == 'K') {
          paycode = 'YOU_NB_Online'
          if (nominal < 500000) paycode = 'YOU_NB_Online500'
        } else if (paymentMedia == 'N') {
          paycode = 'YOU_NB_SINGPAYNONSTU'
        } else if (paymentMedia == 'ADOL' && bankCode == 'MANDONLINE') {
          paycode = 'YOU_NB_ADOLMANDIRI'
          if (nominal < 500000) paycode = 'YOU_NB_ADOLMANDIRI500'
        }
      }

    return paycode
  }

  let isSyariah = SPAJs.spajHeader.isSyariah == 0 ? false : true,
    isVaOnline = SPAJs.spajHeader.isSyariah == 0 ? true : false,
    dataPH = SPAJDetail.dataPH

  let amountpay =  SPAJDetail.dataBenefitSpaj.basic.TotalPremium + (SPAJDetail.dataBenefitSpaj.transactionPlan.AmountTP ? SPAJDetail.dataBenefitSpaj.transactionPlan.AmountTP: 0) + (SPAJDetail.dataBenefitSpaj.basic.PolicyFee ? SPAJDetail.dataBenefitSpaj.basic.PolicyFee: 0)

  const userAgent =
    navigator.userAgent.match(
      /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
    ) || []

  let data = {
    transaction_details: {
      reference_id: ''
    },
    item_details: [
      {
        id: new Date().getTime(),
        price: amountpay,
        quantity: 1,
        name: SPAJDetail.dataSpaj.productCode
      }
    ],
    customer_details: {
      first_name: dataPH.TCLN_FirstName,
      last_name: dataPH.TCLN_LastName,
      email: dataPH.TCLN_Email,
      phone: dataPH.TCLN_MobilePhone,
      address: dataPH.TCLN_HomeAddress
    },
    gopay: {
      enable_callback: false,
      callback_url: ''
    },
    app: 'IPYOU',
    channel: 'AGENCY',
    user_id:
      SPAJDetail.dataFinancial.TRPH_PaymentMethod == 'ADOL'
        ? SPAJs.spajHeader.spajNumber
        : userAgent[1],
    policy_number: '',
    spaj_number: SPAJs.spajHeader.spajNumber,
    transaction_type: 'Pembayaran Polis',
    requested_by: 'iPropose You',
    premium_type: getPaycode(SPAJDetail),
    va_number: vaAccount.numberVa,
    bri_va_number:vaAccountBri.numberVa,
    bni_va_number:vaAccountBni.numberVa,
    mandiri_va_number:vaAccountMandiri.numberVa,
    is_syariah: isSyariah,
    is_reccuring: true,
    is_vaOnline: isVaOnline,
    payorName: '',
    clientId: ''
  }
  
  //update for genwealth pake if USD
  if(SPAJDetail.dataFinancial.TRPH_PaymentCurr == 'USD') {
    let baseUrl = Api.host+ Api.routeVaBca + vaAccount.numberVa
    setUri(baseUrl)
    setStatusPaymentOnline(true)
    setRbCaraBayar('VA')
    setRbCaraBayar1('OF')
    setResponsePayment("Y");
    setVaBank("BCA")
  }
  else
  {
    if (shouldGetToken(isSyariah, vaAccount, vaAccountBni, vaAccountBri, vaAccountMandiri)) {
        ApiPayment.post(`paymentTokenRequest`, data)
          .then(response => {
            if (response.httpStatus == 200 && response.data.result != '') {
              let tokenPayment = response.data.result,
                baseUrl =
                  (isMobile
                    ? ApiPayment.hostPaymentTokenMobile
                    : ApiPayment.hostPyamentToken) + tokenPayment
              setUri(baseUrl)
              sessionStorage.setItem('tokenPayment', tokenPayment)
              triggerIntervalCheckInquiry(
                tokenPayment,
                intervals,
                setIntervals,
                setRbCaraBayar,
                setRbCaraBayar1,
                setResponsePayment,
                setStatusPaymentOnline,
                setVisiblePopupPayment,
                setIsOpenGojek,
                isOpenGojek,
                setIsPayment,
                setisDonePay,
                setVaBank
              )
            } else {
            }
          })
          .catch(e => {

          })
    }
  }

  
}

const shouldGetToken = (isSyariah, vaAccount, vaAccountBni, vaAccountBri, vaAccountMandiri) => {
  if (isSyariah) {
      // Check both vaAccount and vaAccountMandiri for Syariah
      return isNotEmptyObject(vaAccount)
  } else {
      // Check only vaAccount for non-Syariah
      return isNotEmptyObject(vaAccount) && isNotEmptyObject(vaAccountBni)&& isNotEmptyObject(vaAccountBri) && isNotEmptyObject(vaAccountMandiri);

  }
}

const isNotEmptyObject = (obj) => {
  return obj && Object.keys(obj).length > 0;
}

const triggerIntervalCheckInquiry = (
  tokenPayment,
  intervals,
  setIntervals,
  setRbCaraBayar,
  setRbCaraBayar1,
  setResponsePayment,
  setStatusPaymentOnline,
  setVisiblePopupPayment,
  setIsOpenGojek,
  isOpenGojek,
  setIsPayment,
  setisDonePay,
  setVaBank
) => {

  intervals.push(
    setInterval(() => {
      console.log("-->",`gopay/v2/info/get?paymentToken=` + tokenPayment)
      ApiPayment.post(`gopay/v2/info/get?paymentToken=` + tokenPayment, {})
        .then(res => {
          let result = res.data.result
          if (res.httpStatus == 200 && result != null) {
            if (result.status_code == '200' || result.status_code == '201' || result.status_code == '1') {
              if (
                result.payment_type == 'gopay' ||
                result.payment_type == 'qris'
              ) {
                clearInterval(intervals[0])

                setStatusPaymentOnline(true)
                setRbCaraBayar('GOPAY')
                setRbCaraBayar1('ON')
                setResponsePayment('Y')
                setVisiblePopupPayment(true)
                setisDonePay(true)
              } else {
                setStatusPaymentOnline(true)
              }

              if (result.payment_type == 'cc_espay') {
                clearInterval(intervals[0])

                setStatusPaymentOnline(true)
                setRbCaraBayar('BRIO')
                setRbCaraBayar1('ON')
                setResponsePayment('Y')
                setVisiblePopupPayment(true)
                setisDonePay(true)

              } else {
                setStatusPaymentOnline(true)
              }

              if (result.payment_type == 'Credit Card') {
                clearInterval(intervals[0])

                setStatusPaymentOnline(true)
                setRbCaraBayar('CCOL')
                setRbCaraBayar1('ON')
                setResponsePayment('Y')
                setVisiblePopupPayment(true)
                setisDonePay(true)

              } else {
                setStatusPaymentOnline(true)
              }

              if (result.payment_type == 'Mandiri Autodebit') {
                clearInterval(intervals[0])

                setStatusPaymentOnline(true)
                setRbCaraBayar('ADOL')
                setRbCaraBayar1('ON')
                setResponsePayment('Y')
                setVisiblePopupPayment(true)
                setisDonePay(true)

              } else {
                setStatusPaymentOnline(true)
              }

              clearInterval(intervals[0])
            } else if (
              result.paymentType != null &&
              result.paymentType.includes('va')
            ) {
              // console.log('SUKSES BAYAR VIRTUAL ACCOUNT')
              clearInterval(intervals[0])

              setStatusPaymentOnline(true)
              setRbCaraBayar('VA')
              setRbCaraBayar1(
                result.paymentType.includes('offline') ? 'OF' : 'ON'
              )

              if (result.paymentType.includes('permata')) {
                console.log("BANK va_offline_permata")
                setResponsePayment("Y");
                setVaBank("PERMATA")
              } else {

                if (result.paymentType.includes('mandiri'))
                {
                  console.log("BANK va_online_mandiri_snap")

                  setVaBank("MANDIRI")
                }

                if (result.paymentType.includes('bri'))
                {
                  console.log("BANK va_online_bri_snap")

                  setVaBank("BRI")
                }

                if (result.paymentType.includes('bni'))
                {
                  console.log("BANK va_online_bni_snap")

                  setVaBank("BNI")
                }

                if (result.paymentType.includes('bca'))
                {
                  console.log("BANK va_online_bca")

                  setVaBank("BCA")
                }                
                
                setResponsePayment(
                  result.paymentType.includes('offline') ? 'N' : 'Y'
                )
              }
            }
          }

          if (
            res.data.result.status_code == '201' &&
            res.data.result.payment_type == 'gopay'
          ) {
            // console.log(' ======= CHECK STATUS BY TOKEN GOPAY =======')
            let midtransResult = res.data.result.midtrans_result
            let json = midtransResult.substring(1, midtransResult.length, -1)
            let actions = JSON.parse(midtransResult).actions

            actions.forEach(action => {
              if (action.name == 'deeplink-redirect' && isOpenGojek == false && isMobile) {
                setIsOpenGojek(true);
                let deeplinkUrl = action.url
                if (deeplinkUrl.includes('https://gojek.link/gopay')) {
                  deeplinkUrl = deeplinkUrl.replace('https://gojek.link/gopay', 'gojek://gopay')
                }

                if (typeof (window.open) == "function") {
                  window.open(deeplinkUrl, '_top');
                }else {
                  window.top.location.href = deeplinkUrl;
                }
              }
            })
            intervals.push(
              setInterval(() => {
                getResponseGopay(tokenPayment)
              }, 10000)
            )
          }
        })
        .catch(e => {
          // console.log('error fetch check status inquiry', e)
          return e
        })
    }, 10000)
  )

  setIntervals([...intervals])
}

const getResponseGopay = tokenPayment => {
  ApiPayment.get(
    `midtrans/checkstatusbytoken?tokenPayment=` + tokenPayment,
    {}
  ).then(response => {
    // console.log('RESP getResponseGopay : ', response)
  })
}

const updatePaymentCc = (
  SPAJs,
  SPAJDetail,
  DeviceId,
  paymentData,
  responsePayment,
  dispatch,
  navigate,
  rbCaraBayar,
  rbCaraBayar1,
  setWordingModal,
  setShowPopupLengkapi,
  setLoading
) => {
  let hash =
    SPAJs.spajHeader.spajNumber + 'j$J79jnnFX62*F71aamfFiFLcnGyQ29NmcYtJf#@'
  let param = {
    spajNumber: SPAJs.spajHeader.spajNumber,
    signature: sha3_256(hash),
    deviceId: DeviceId.deviceId,
    userName: SPAJs.spajHeader.userName
  }

  Api.post(Api.routeEapp+MasterApi.updatePaymentCC, param).then(resp => {
    // console.log('REQUEST updatePaymentCc: ', resp)
    if (resp.status == 'OK' || resp.status == 'ERROR') {
      insUpdPaymentData(
        SPAJs,
        SPAJDetail,
        DeviceId,
        paymentData,
        responsePayment,
        rbCaraBayar,
        rbCaraBayar1,
        setWordingModal,
        setShowPopupLengkapi,
        setLoading
      )

      callUpdateStatusSpaj(SPAJs, DeviceId, responsePayment, dispatch, navigate,setWordingModal, setShowPopupLengkapi, setLoading)
    } else {
    }
  })
}

const updatePaymentCcOnly = (
  SPAJs,
  SPAJDetail,
  DeviceId,
  paymentData,
  responsePayment,
  dispatch,
  navigate,
  rbCaraBayar,
  rbCaraBayar1,
  setWordingModal,
  setShowPopupLengkapi,
  setLoading
) => {
  let hash =
    SPAJs.spajHeader.spajNumber + 'j$J79jnnFX62*F71aamfFiFLcnGyQ29NmcYtJf#@'
  let param = {
    spajNumber: SPAJs.spajHeader.spajNumber,
    signature: sha3_256(hash),
    deviceId: DeviceId.deviceId,
    userName: SPAJs.spajHeader.userName
  }

  Api.post(Api.routeEapp+MasterApi.updatePaymentCC, param).then(resp => {
    console.log('REQUEST updatePaymentCcOnly: ', resp.status)

    updatePaymentAdolOnly(
      SPAJs,
      SPAJDetail,
      DeviceId,
      paymentData,
      responsePayment,
      dispatch,
      navigate,
      rbCaraBayar,
      rbCaraBayar1,
      setWordingModal,
      setShowPopupLengkapi,
      setLoading
    )

  })
}

const updatePaymentAdol = (
  SPAJs,
  SPAJDetail,
  DeviceId,
  paymentData,
  responsePayment,
  dispatch,
  navigate,
  rbCaraBayar,
  rbCaraBayar1,
  setWordingModal,
  setShowPopupLengkapi,
  setLoading
) => {
  let hash =
    SPAJs.spajHeader.spajNumber + 'XQJ72jnnFXJ78DccnyR4FiFLcnGyQ99KmuI9I90I'
  let param = {
    spajNumber: SPAJs.spajHeader.spajNumber,
    signature: sha3_256(hash),
    deviceId: DeviceId.deviceId,
    userName: SPAJs.spajHeader.userName
  }

  // console.log('REQUEST updatePaymentAdol: ', param)
  Api.post(Api.routeEapp+MasterApi.updatePaymentAdol, param).then(resp => {
    if (resp.status == 'OK' || resp.status == 'ERROR') {
      insUpdPaymentData(
        SPAJs,
        SPAJDetail,
        DeviceId,
        paymentData,
        responsePayment,
        rbCaraBayar,
        rbCaraBayar1,
        setWordingModal,
        setShowPopupLengkapi,
        setLoading
      )

      callUpdateStatusSpaj(SPAJs, DeviceId, responsePayment, dispatch, navigate,setWordingModal, setShowPopupLengkapi, setLoading)
    } else {
    }
  })
}

const updatePaymentAdolOnly = (
  SPAJs,
  SPAJDetail,
  DeviceId,
  paymentData,
  responsePayment,
  dispatch,
  navigate,
  rbCaraBayar,
  rbCaraBayar1,
  setWordingModal,
  setShowPopupLengkapi,
  setLoading
) => {
  let hash =
    SPAJs.spajHeader.spajNumber + 'XQJ72jnnFXJ78DccnyR4FiFLcnGyQ99KmuI9I90I'
  let param = {
    spajNumber: SPAJs.spajHeader.spajNumber,
    signature: sha3_256(hash),
    deviceId: DeviceId.deviceId,
    userName: SPAJs.spajHeader.userName
  }

  // console.log('REQUEST updatePaymentAdol: ', param)
  Api.post(Api.routeEapp+MasterApi.updatePaymentAdol, param).then(resp => {
        console.log('REQUEST updatePaymentAdolOnly: ', resp.status)
        kirimspaj( SPAJs,DeviceId,dispatch,navigate, setWordingModal,setShowPopupLengkapi, setLoading);
  })
}

const insUpdPaymentData = async (
  SPAJs,
  SPAJDetail,
  DeviceId,
  paymentData,
  responsePayment,
  rbCaraBayar,
  rbCaraBayar1,
  vaAccount,
  dispatch,
  navigate,
  setWordingModal,
  setShowPopupLengkapi,
  setLoading,
  vaAccountBni,
  vaAccountBri,
  vaAccountMandiri,
  vaBank,
) => {
  function mappingSubmitDataExist () {
    let { userName } = SPAJs.spajHeader
    let request = {
      deviceId: DeviceId.deviceId,
      spajNumber: paymentData.spajNumber,
      agentCode: paymentData.agentCode,
      paymentMethod: paymentData.paymentMethod,
      paymentType: paymentData.paymentType,
      accountNumber:
        paymentData.paymentType === 'VA'
          ? paymentData.accountNumber
          : '',
      isPayment: paymentData.isPayment,
      userName: userName
    }

    return request
  }

  function mappingSubmitDataInitial () {
    console.log("vaBank",vaBank)
    // console.log("vaAccount",vaAccount)
    // console.log("vaAccountBni",vaAccountBni)
    // console.log("vaAccountBri",vaAccountBri)
    // console.log("vaAccountMandiri",vaAccountMandiri)

    let request = {
      deviceId: DeviceId.deviceId,
      spajNumber: SPAJs.spajHeader.spajNumber,
      agentCode: SPAJDetail.dataPH.TCLN_AgentCode,
      paymentMethod: rbCaraBayar1,
      paymentType: rbCaraBayar,
      accountNumber: rbCaraBayar === 'VA' ? (vaBank === 'BCA' || vaBank === 'PERMATA') ? vaAccount.numberVa : (vaBank === 'MANDIRI') ? vaAccountMandiri.numberVa : (vaBank === 'BNI') ? vaAccountBni.numberVa : (vaBank === 'BRI') ? vaAccountBri.numberVa : '' : '',
      isPayment:
        rbCaraBayar === 'VA'
          ? SPAJs.spajHeader.isSyariah == 0
            ? 'Y'
            : 'N'
          : responsePayment,
      userName: SPAJDetail.dataPH.TCLN_Email
    }

    return request
  }

  let tmpRequest = {}
  if (
    paymentData.isPayment == 'Y' ||
    paymentData.paymentType === 'VA'
  ) {
    tmpRequest = await mappingSubmitDataExist()
  } else {
    tmpRequest = await mappingSubmitDataInitial()
  }

  Api.post(Api.routeEapp+MasterApi.insUpdPaymentData, tmpRequest).then(resp => {
    if (resp.status == 'OK' || resp.httpStatus == 406) {
      if (rbCaraBayar === 'VA' || responsePayment === 'Y') {
        callUpdateStatusSpaj(
          SPAJs,
          DeviceId,
          responsePayment,
          dispatch,
          navigate,
          setWordingModal,
          setShowPopupLengkapi,
          setLoading
        )
      }
    } else {
    }
  })
}

const lanjutPembayaran = (
  SPAJs,
  SPAJDetail,
  DeviceId,
  rbCaraBayar,
  setVisiblePopupVa,
  paymentData,
  responsePayment,
  rbCaraBayar1,
  vaAccount,
  dispatch,
  navigate,
  setWordingModal,
  setShowPopupLengkapi,
  setLoading,
  vaAccountBni,
  vaAccountBri,
  vaAccountMandiri,
  vaBank,
) => {
  let metodePembayaran = SPAJDetail.dataFinancial.TRPH_PaymentMethod,
    bankCode = SPAJDetail.dataFinancial.TRPD_BankCode

  if (
    (metodePembayaran === 'K' ||
      (metodePembayaran == 'ADOL' && bankCode == 'MANDONLINE')) &&
    rbCaraBayar == 'VA'
  ) {
    changePaymentVa(
      SPAJs,
      SPAJDetail,
      DeviceId,
      paymentData,
      responsePayment,
      rbCaraBayar,
      rbCaraBayar1,
      vaAccount,
      dispatch,
      navigate,
      setWordingModal,
      setShowPopupLengkapi,
      setLoading,
      vaAccountBni,
      vaAccountBri,
      vaAccountMandiri,
      vaBank,
    )
  } else {
    if (metodePembayaran === 'K' && (rbCaraBayar === 'CCOL' || rbCaraBayar === 'BRIO')) {
      updatePaymentCc(
        SPAJs,
        SPAJDetail,
        DeviceId,
        paymentData,
        responsePayment,
        dispatch,
        navigate,
        rbCaraBayar,
        rbCaraBayar1,
        setWordingModal,
        setShowPopupLengkapi,
        setLoading
      )
    } else if (metodePembayaran === 'ADOL' && rbCaraBayar === 'ADOL') {
      updatePaymentAdol(
          SPAJs,
          SPAJDetail,
          DeviceId,
          paymentData,
          responsePayment,
          dispatch,
          navigate,
          rbCaraBayar,
          rbCaraBayar1,
          setWordingModal,
          setShowPopupLengkapi,
          setLoading
      )
    } else {
      insUpdPaymentData(
        SPAJs,
        SPAJDetail,
        DeviceId,
        paymentData,
        responsePayment,
        rbCaraBayar,
        rbCaraBayar1,
        vaAccount,
        dispatch,
        navigate,
        setWordingModal,
        setShowPopupLengkapi,
        setLoading,
        vaAccountBni,
        vaAccountBri,
        vaAccountMandiri,
        vaBank,
      )
    }
  }
}

const changePaymentVa = (
  SPAJs,
  SPAJDetail,
  DeviceId,
  paymentData,
  responsePayment,
  rbCaraBayar,
  rbCaraBayar1,
  vaAccount,
  dispatch,
  navigate,
  setWordingModal,
  setShowPopupLengkapi,
  setLoading,
  vaAccountBni,
  vaAccountBri,
  vaAccountMandiri,
  vaBank,
) => {
  let param = {
    deviceId: DeviceId.deviceId,
    spajNumber: SPAJs.spajHeader.spajNumber,
    agentCode: SPAJDetail.dataPH.TCLN_AgentCode,
    paymentMethod: 'C',
    userName: SPAJs.spajHeader.userName
  }

  Api.post(Api.routeEapp+MasterApi.changePaymentVa, param).then(resp => {
    if (resp.status == 'OK') {
      insUpdPaymentData(
        SPAJs,
        SPAJDetail,
        DeviceId,
        paymentData,
        responsePayment,
        rbCaraBayar,
        rbCaraBayar1,
        vaAccount,
        dispatch,
        navigate,
        setWordingModal,
        setShowPopupLengkapi,
        setLoading,
        vaAccountBni,
        vaAccountBri,
        vaAccountMandiri,
        vaBank,
      )
      callUpdateStatusSpaj(SPAJs, DeviceId, responsePayment, dispatch, navigate,setWordingModal, setShowPopupLengkapi, setLoading)
    } else {
    }
  })
}

const checkNextStep = (
  SPAJs,
  SPAJDetail,
  DeviceId,
  rbCaraBayar,
  setVisiblePopupVa,
  paymentData,
  responsePayment,
  rbCaraBayar1,
  vaAccount,
  dispatch,
  navigate,
  isPayment,
  setWordingModal,
  setShowPopupLengkapi,
  setLoading,
  vaAccountBni,
  vaAccountBri,
  vaAccountMandiri,
  vaBank,
) => {
  let metodePembayaran = SPAJDetail.dataFinancial.TRPH_PaymentMethod,
    bankCode = SPAJDetail.dataFinancial.TRPD_BankCode

  if (isPayment) {
    sessionStorage.removeItem('tokenPayment')
    dispatch(updateStatusCustomer("P"));
    if (SPAJs.spajHeader?.isUnitLink == 0)     
      {
        updatePaymentCcOnly(
          SPAJs,
          SPAJDetail,
          DeviceId,
          paymentData,
          responsePayment,
          dispatch,
          navigate,
          rbCaraBayar,
          rbCaraBayar1,
          setWordingModal,
          setShowPopupLengkapi,
          setLoading
        )
      }
      
    // else navigate('/finalstep')
  } else {
    if (
      (metodePembayaran === 'K' ||
        (metodePembayaran == 'ADOL' && bankCode == 'MANDONLINE')) &&
      rbCaraBayar == 'VA'
    ) {
      setVisiblePopupVa(true)
    } else {
      lanjutPembayaran(
        SPAJs,
        SPAJDetail,
        DeviceId,
        rbCaraBayar,
        setVisiblePopupVa,
        paymentData,
        responsePayment,
        rbCaraBayar1,
        vaAccount,
        dispatch,
        navigate,
        setWordingModal,
        setShowPopupLengkapi,
        setLoading,
        vaAccountBni,
        vaAccountBri,
        vaAccountMandiri,
        vaBank,
      )
    }
  }
}


const kirimspaj = (
  SPAJs,
  DeviceId,
  dispatch,
  navigate,
  setWordingModal,
  setShowPopupLengkapi,
  setLoading
) =>{
  let insertData = {
    deviceId: `${DeviceId.deviceId}`,
    userName: `${SPAJs.spajHeader?.userName}`,
    spajNumber: `${SPAJs.spajHeader?.spajNumber}`,
  };
  dispatch(checkValid(insertData)).then((res2) => {
    if (res2.payload.status == "OK") {
      console.log("OTPKONFIRMASI")
      navigate("/otp-konfirmasi");
    } else {
      let msg = res2.payload.status_message || res2.payload.errMsg || res2.payload.error || 'Terjadi Kesalahan'
      setWordingModal(msg);
      setShowPopupLengkapi(true);
    }
  });
}


const callUpdateStatusSpaj = (
  SPAJs,
  DeviceId,
  responsePayment,
  dispatch,
  navigate,
  setWordingModal,
  setShowPopupLengkapi,
  setLoading
) => {
  let detailData = {
    deviceId: `${DeviceId.deviceId}`,
    userName: `${SPAJs.spajHeader?.userName}`,
    spajNumber: `${SPAJs.spajHeader?.spajNumber}`,
    agentStatus: 'IPC',
    customerStatus: responsePayment == 'Y' ? 'P' : 'C'
  }
  dispatch(updateStatusSpaj(detailData)).then(res => {
    dispatch(updateStatusCustomer(responsePayment == 'Y' ? 'P' : 'C'))
    kirimspaj( SPAJs,DeviceId,dispatch,navigate,
      setWordingModal,
      setShowPopupLengkapi,
      setLoading);
    // if (SPAJs.spajHeader?.isUnitLink == 0) navigate('/formfinalstep')
    // else navigate('/finalstep')
  })
}

const hidePopup = setVisiblePopupVa => {
  setVisiblePopupVa(false)
}

const hidePopupPayment = setVisiblePopupPayment => {
  setVisiblePopupPayment(false)
}

const Pembayaran = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { SPAJs } = useSelector(state => state.SPAJs)
  const { DeviceId } = useSelector(state => state.DeviceId)
  const { SPAJDetail } = useSelector(state => state.SPAJsDetail)
  const [statusCustomer, setStatusCustomer] = useState('')
  const [isUnitLink, setIsUnitLink] = useState(0);
  const [loading, setLoading] = useState(false)
  const [uri, setUri] = useState('')
  const [statusPaymentOnline, setStatusPaymentOnline] = useState(false)
  const [visiblePopupVa, setVisiblePopupVa] = useState(false)
  const [visiblePopupPayment, setVisiblePopupPayment] = useState(false)
  const [isDataLoaded, setIsDataLoaded] = useState(false)
  const [vaAccount, setVaAccount] = useState({})
  const [vaAccountBni, setVaAccountBni] = useState({})
  const [vaAccountBri, setVaAccountBri] = useState({})
  const [vaAccountMandiri, setVaAccountMandiri] = useState({})
  const [vaBank, setVaBank] = useState({})
  const [rbCaraBayar, setRbCaraBayar] = useState('')
  const [rbCaraBayar1, setRbCaraBayar1] = useState('')
  const [paymentData, setPaymentData] = useState({})
  const [intervals, setIntervals] = useState([])
  const [responsePayment, setResponsePayment] = useState(false)
  const [isPayment, setIsPayment] = useState(false)
  const [isDonePay, setisDonePay] = useState(false)
  const [isOpenGojek, setIsOpenGojek] = useState(false)
  let [wordingModal, setWordingModal] = useState("Terjadi Kesalahan");
  let [showPopupLengkapi, setShowPopupLengkapi] = useState(false);

  useEffect(() => {
      setStatusCustomer(StatusCustomer(SPAJs.spajHeader.statusCustomer,SPAJs.spajHeader?.isUnitLink))
      setIsUnitLink(SPAJs.spajHeader?.isUnitLink);
      setLoading(true)
      if (isDataLoaded == false) {
        getPaymentData(
          SPAJs,
          SPAJDetail,
          DeviceId,
          setRbCaraBayar,
          setRbCaraBayar1,
          setPaymentData,
          setIsOpenGojek
        )
        getOfflinePayment(SPAJs, SPAJDetail, DeviceId, setVaAccount,setVaAccountBni,setVaAccountBri,setVaAccountMandiri)
  
        setLoading(false)
        setIsDataLoaded(true)
      }
  
      return () => {
        setIntervals([])
      }
  }, [])

  useEffect(() => {
    console.log("vaAccount",JSON.stringify(vaAccount))
    if (JSON.stringify(vaAccount) != '{}') {
      if (paymentData && paymentData.isPayment == 'Y') {
        setIsPayment(true)
      } else {
        if (sessionStorage.getItem('tokenPayment') == null) {
          getTokenPayment(
            SPAJDetail,
            SPAJs,
            vaAccount,
            setUri,
            intervals,
            setIntervals,
            setRbCaraBayar,
            setRbCaraBayar1,
            setResponsePayment,
            setStatusPaymentOnline,
            setVisiblePopupPayment,
            setIsOpenGojek,
            isOpenGojek,
            setIsPayment,
            setisDonePay,
            vaAccountBni,
            vaAccountBri,
            vaAccountMandiri,
            setVaBank
          )
          setLoading(false)
        } else {
          if(uri === '')
          {
            let baseUrl =
            (isMobile
              ? ApiPayment.hostPaymentTokenMobile
              : ApiPayment.hostPyamentToken) + sessionStorage.getItem('tokenPayment')
            setUri(baseUrl)
          }
          triggerIntervalCheckInquiry(
            sessionStorage.getItem('tokenPayment'),
            intervals,
            setIntervals,
            setRbCaraBayar,
            setRbCaraBayar1,
            setResponsePayment,
            setStatusPaymentOnline,
            setVisiblePopupPayment,
            setIsOpenGojek,
            isOpenGojek,
            setIsPayment,
            setisDonePay,
            setVaBank
          )
        }
      }
    }
  }, [paymentData, vaAccount, vaAccountBni, vaAccountBri, vaAccountMandiri, vaBank])

  useEffect(() => {
    if (statusPaymentOnline && intervals.length > 0) {
      clearInterval(intervals[0])
      clearInterval(intervals[1])
    }
  }, [statusPaymentOnline])

  
  const ModalLengkapi = ({
    showPopupLengkapi,
    setShowPopupLengkapi,
    wordingModal,
  }) => {
    return (
      <>
        <Modal
          dialogClassName={styles.modalcustom}
          centered
          show={showPopupLengkapi}
        >
          <Modal.Body>
            <div className={styles.containerModal}>
              <p className="fs-15 text-center mb-25">{wordingModal}</p>
              <div onClick={() => setShowPopupLengkapi(false)}>
                <div>
                  <button className={styles.buttonnextmodal}>OK</button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  };

// const kirimspaj = () =>{
//   let insertData = {
//     deviceId: `${DeviceId.deviceId}`,
//     userName: `${SPAJDetail.dataSpaj.email}`,
//     spajNumber: `${SPAJDetail.dataSpaj.spajNumber}`,
//   };
//   dispatch(checkValid(insertData)).then((res2) => {
//     if (res2.payload.status == "OK") {
//       setLoading(false);
//       navigate("/otpkonfirmasi");
//     } else {
//       setLoading(false);
//       let msg = res2.payload.status_message || res2.payload.errMsg || res2.payload.error || 'Terjadi Kesalahan'
//       setWordingModal(msg);
//       setShowPopupLengkapi(true);
//       setLoading(false);  
//     }
//   });
// }

const handleCekStatusPembayaran = async () => {
  setLoading(true);
  const param = {
    spajNumber: SPAJs.spajHeader.spajNumber,
    agentCode: SPAJDetail.dataPH.TCLN_AgentCode,
    deviceId: DeviceId.deviceId,
    userName: SPAJs.spajHeader.userName
  };
  Api.post(Api.routeEapp+MasterApi.checkStatusPayment, param)
  .then(res => {  
    setLoading(false);
    if (res.status === 'OK' && res.data?.paymentType) {

      if(res.data?.paymentType === "VA")
      {
        if(res.data?.payhubPaymentType.includes('permata'))
        {
          setVaBank("PERMATA")
        }
        else if(res.data?.payhubPaymentType.includes('mandiri'))
        {
          setVaBank("MANDIRI")
        }
        else if(res.data?.payhubPaymentType.includes('bri'))
        {
          setVaBank("BRI")
        }else if(res.data?.payhubPaymentType.includes('bni'))
        {
          setVaBank("BNI")
        }else {
            setVaBank("BCA")
        }        
      }
      setWordingModal('Pembayaran Berhasil');
      setResponsePayment('Y');
      setVisiblePopupPayment(true);
      setStatusPaymentOnline(true)
      setRbCaraBayar(res.data?.paymentType)
      setRbCaraBayar1(res.data?.paymentMethod)
      setisDonePay(true)
    } else {
      setWordingModal('Pembayaran Belum diterima');
      setShowPopupLengkapi(true);
    }
  }).catch((err) => {
    setLoading(false);
    setWordingModal('Gagal Menghubungi Server. Silakan Coba Lagi.');
    setShowPopupLengkapi(true)
  });
};

  const PremiTopUpBerkala = () => {
    return (
      <>
        {SPAJs.spajHeader.isSyariah == 0 ? (
          <>
            <div className={styles.flexall}>
              <div className={styles.flexfildwording}>
                <div> Premi Top Up Berkala</div>
              </div>
              <div className={styles.flexfild}>
                <div className={styles.borderpembayarannew}>
                  {formatCurrencyNew(SPAJDetail.dataBenefitSpaj.basic.RTU, true,SPAJDetail.dataFinancial.TRPH_PaymentCurr)}
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className={styles.flexall}>
              <div className={styles.flexfildwording}>
                <div> Kontribusi Top Up Berkala</div>
              </div>
              <div className={styles.flexfild}>
                <div className={styles.borderpembayarannew}>
                  {formatCurrencyNew(SPAJDetail.dataBenefitSpaj.basic.RTU, true,SPAJDetail.dataFinancial.TRPH_PaymentCurr)}
                </div>
              </div>
            </div>
          </>
        )}
      </>
    )
  }

  const PremiRider = () => {
    return (
      <>
        {SPAJs.spajHeader.isSyariah == 0 ? (
          <>
            <div className={styles.flexall}>
              <div className={styles.flexfildwording}>
                <div> Premi Rider</div>
              </div>
              <div className={styles.flexfild}>
                <div className={styles.borderpembayarannew}>
                  {formatCurrencyNew(
                        SPAJDetail.dataBenefitSpaj.basic.RiderPremium
                    ,true,SPAJDetail.dataFinancial.TRPH_PaymentCurr
                  )}
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className={styles.flexall}>
              <div className={styles.flexfildwording}>
                <div> Kontribusi Rider</div>
              </div>
              <div className={styles.flexfild}>
                <div className={styles.borderpembayarannew}>
                  {formatCurrencyNew(
                     SPAJDetail.dataBenefitSpaj.basic.RiderPremium
                    ,true,SPAJDetail.dataFinancial.TRPH_PaymentCurr
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </>
    )
  }

  const TopUpTunggal = () => {
    return (
      <>
        {SPAJs.spajHeader.isSyariah == 0 ? (
          <>
            <div className={styles.flexall}>
              <div className={styles.flexfildwording}>
                <div> Premi Top Up Tunggal</div>
              </div>
              <div className={styles.flexfild}>
                <div className={styles.borderpembayarannew}>
                  {formatCurrencyNew(
                    // SPAJDetail.dataBenefitSpaj.basic.RiderPremium,
                    // true
                    SPAJDetail.dataBenefitSpaj.transactionPlan.AmountTP,
                    true,SPAJDetail.dataFinancial.TRPH_PaymentCurr
                  )}
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className={styles.flexall}>
              <div className={styles.flexfildwording}>
                <div> Kontribusi Top Up Tunggal</div>
              </div>
              <div className={styles.flexfild}>
                <div className={styles.borderpembayarannew}>
                  {formatCurrencyNew(
                    SPAJDetail.dataBenefitSpaj.transactionPlan.AmountTP,
                    true,SPAJDetail.dataFinancial.TRPH_PaymentCurr
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </>
    )
  }

  const CetakPolis = () => {
    return (
      <>
        <div className={styles.flexall}>
          <div className={styles.flexfildwording}>
            <div> Biaya Cetak Polis</div>
          </div>
          <div className={styles.flexfild}>
            <div className={styles.borderpembayarannew}>
              {formatCurrencyNew(
                SPAJDetail.dataBenefitSpaj.basic.PolicyFee,
                true,SPAJDetail.dataFinancial.TRPH_PaymentCurr
              )}
            </div>
          </div>
        </div>
        <div className={styles.flexall}>
          <div className={styles.flexfildwording}>
            <div> Total Pembayaran</div>
          </div>
          <div className={styles.flexfild}>
            <div className={styles.borderpembayarannew}>
              {formatCurrencyNew(
                SPAJDetail.dataBenefitSpaj.basic.TotalPremium +
                (SPAJDetail.dataBenefitSpaj.transactionPlan.AmountTP ? SPAJDetail.dataBenefitSpaj.transactionPlan.AmountTP : 0) + 
                (SPAJDetail.dataBenefitSpaj.basic.PolicyFee ? SPAJDetail.dataBenefitSpaj.basic.PolicyFee : 0),
                true,SPAJDetail.dataFinancial.TRPH_PaymentCurr
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
  return (
    <>
     {showPopupLengkapi == true && (
          <ModalLengkapi
            showPopupLengkapi={showPopupLengkapi}
            setShowPopupLengkapi={setShowPopupLengkapi}
            wordingModal={wordingModal}
          />
        )}
      {statusCustomer < 5 &&<LockScreen/>}
      {loading == true && <Spinners />}
      <div>
        <Header />
        <div>
          <div className='g-0 welcome-container'>
            <div className={`position-relative ${styles.bgContainer}`}>
              <ProgressBar step='4' status={statusCustomer} isUnitlink={isUnitLink}/>
              <div className={styles.allCardGreyPembayaran}>
                <div className={styles.flexcontainer}>
                  <div className={styles.flexitemleft} style={{ left: '25%' }}>
                    {isPayment || isDonePay ? (
                      <div>
                        <img
                          src='images/checked.png'
                          className={styles.iconChecked}
                        />
                        <div className={styles.textPayment}>
                          Pembayaran Berhasil
                        </div>
                      </div>
                    ) : (
                      <div class={styles.iframeLoading}>
                      <iframe
                        style={{minHeight:470}}
                        width='100%'
                        height='100%'
                        src={uri}
                        id='frame'
                      />
                      </div>
                    )}
                  </div>
                  <div className={styles.flexitemright}>
                    <div className='p-20'>
                      <div className={styles.wordingtext}>
                        Detail Pembayaran
                      </div>
                      {SPAJs.spajHeader.isUnitLink == 1 ? (
                        <>
                          {SPAJs.spajHeader.isSyariah == 1 ? (
                            <>
                              <div className={styles.flexall}>
                                <div className={styles.flexfildwording}>
                                  <div> Kontribusi Dasar</div>
                                </div>
                                <div className={styles.flexfild}>
                                  <div className={styles.borderpembayarannew}>
                                    {formatCurrencyNew(
                                      SPAJDetail.dataBenefitSpaj.basic.Premium,
                                      true,SPAJDetail.dataFinancial.TRPH_PaymentCurr
                                    )}
                                  </div>
                                </div>
                              </div>

                              {SPAJDetail.dataBenefitSpaj.basic.RiderPremium !=
                                0 && <PremiRider />}
                              {SPAJDetail.dataBenefitSpaj.basic.RTU != 0 && (
                                <PremiTopUpBerkala />
                              )}
                              {SPAJDetail.dataBenefitSpaj.transactionPlan
                                .AmountTP && <TopUpTunggal />}

                              <div className={styles.flexall}>
                                <div className={styles.flexfildwording}>
                                  <div>Total Kontribusi</div>
                                </div>
                                <div className={styles.flexfild}>
                                  <div className={styles.borderpembayarannew}>
                                    {formatCurrencyNew(
                                      SPAJDetail.dataBenefitSpaj.basic
                                        .TotalPremium +
                                        (SPAJDetail.dataBenefitSpaj
                                          .transactionPlan.AmountTP
                                          ? SPAJDetail.dataBenefitSpaj
                                              .transactionPlan.AmountTP
                                          : 0),
                                      true,SPAJDetail.dataFinancial.TRPH_PaymentCurr
                                    )}
                                  </div>
                                </div>
                              </div>

                              <CetakPolis />
                            </>
                          ) : (
                            <>
                              <div className={styles.flexall}>
                                <div className={styles.flexfildwording}>
                                  <div>Premi Dasar</div>
                                </div>
                                <div className={styles.flexfild}>
                                  <div className={styles.borderpembayarannew}>
                                    {formatCurrencyNew(
                                      SPAJDetail.dataBenefitSpaj.basic.Premium,
                                      true,SPAJDetail.dataFinancial.TRPH_PaymentCurr
                                    )}
                                  </div>
                                </div>
                              </div>

                              {SPAJDetail.dataBenefitSpaj.basic.RTU != 0 && (
                                <PremiTopUpBerkala />
                              )}
                              {SPAJDetail.dataBenefitSpaj.basic.RiderPremium !=
                                0 && <PremiRider />}
                              {SPAJDetail.dataBenefitSpaj.transactionPlan
                                .AmountTP && <TopUpTunggal />}

                              <div className={styles.flexall}>
                                <div className={styles.flexfildwording}>
                                  <div>Total Premi</div>
                                </div>
                                <div className={styles.flexfild}>
                                  <div className={styles.borderpembayarannew}>
                                    {formatCurrencyNew(
                                      SPAJDetail.dataBenefitSpaj.basic
                                        .TotalPremium +
                                        (SPAJDetail.dataBenefitSpaj
                                          .transactionPlan.AmountTP
                                          ? SPAJDetail.dataBenefitSpaj
                                              .transactionPlan.AmountTP
                                          : 0),
                                      true,SPAJDetail.dataFinancial.TRPH_PaymentCurr
                                    )}
                                  </div>
                                </div>
                              </div>

                              <CetakPolis />
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          {SPAJs.spajHeader.isSyariah == 1 ? (
                            <>
                              <div className={styles.flexall}>
                                <div className={styles.flexfildwording}>
                                  <div> Kontribusi Dasar</div>
                                </div>
                                <div className={styles.flexfild}>
                                  <div className={styles.borderpembayarannew}>
                                    {formatCurrencyNew(
                                      SPAJDetail.dataBenefitSpaj.basic
                                        .TotalPremium,
                                      true,SPAJDetail.dataFinancial.TRPH_PaymentCurr
                                    )}
                                  </div>
                                </div>
                              </div>

                              <div className={styles.flexall}>
                                <div className={styles.flexfildwording}>
                                  <div> Total Kontribusi</div>
                                </div>
                                <div className={styles.flexfild}>
                                  <div className={styles.borderpembayarannew}>
                                    {formatCurrencyNew(
                                      SPAJDetail.dataBenefitSpaj.basic
                                        .TotalPremium +
                                        (SPAJDetail.dataBenefitSpaj
                                          .transactionPlan.AmountTP
                                          ? SPAJDetail.dataBenefitSpaj
                                              .transactionPlan.AmountTP
                                          : 0),
                                      true,SPAJDetail.dataFinancial.TRPH_PaymentCurr
                                    )}
                                  </div>
                                </div>
                              </div>
                              <CetakPolis />
                            </>
                          ) : (
                            <>
                              <div className={styles.flexall}>
                                <div className={styles.flexfildwording}>
                                  <div>Premi Dasar</div>
                                </div>
                                <div className={styles.flexfild}>
                                  <div className={styles.borderpembayarannew}>
                                    {formatCurrencyNew(
                                      SPAJDetail.dataBenefitSpaj.basic.Premium,
                                      true,SPAJDetail.dataFinancial.TRPH_PaymentCurr
                                    )}
                                  </div>
                                </div>
                              </div>

                              {SPAJDetail.dataBenefitSpaj.basic
                                      .RiderPremium != 0 && <PremiRider />}
                              {SPAJDetail.dataBenefitSpaj.transactionPlan
                                .AmountTP && <TopUpTunggal />}

                              <div className={styles.flexall}>
                                <div className={styles.flexfildwording}>
                                  <div> Total Premi</div>
                                </div>
                                <div className={styles.flexfild}>
                                  <div className={styles.borderpembayarannew}>
                                    {formatCurrencyNew(
                                      SPAJDetail.dataBenefitSpaj.basic
                                        .TotalPremium +
                                        (SPAJDetail.dataBenefitSpaj
                                          .transactionPlan.AmountTP
                                          ? SPAJDetail.dataBenefitSpaj
                                              .transactionPlan.AmountTP
                                          : 0),
                                      true,SPAJDetail.dataFinancial.TRPH_PaymentCurr
                                    )}
                                  </div>
                                </div>
                              </div>
                              <CetakPolis />
                            </>
                          )}
                        </>
                      )}
                    </div>
                    { !statusPaymentOnline && !isPayment  ?
                    <Button style={{backgroundColor:'#C32924', marginTop:'20px', width:'100%'}}
                       onClick={handleCekStatusPembayaran}>
                       Cek Status Pembayaran
                    </Button>: null
                    }
                    {/* Batasss */}
                    <div className='mt-40'>
                      <div>
                        {!statusPaymentOnline && !isPayment ? (
                          <div className={styles.counterText}>
                            <p className='col-12'>
                              Mohon maaf pembayaran Anda belum kami terima
                              <br />
                              Harap melakukan pembayaran untuk melanjutkan
                            </p>
                          </div>
                        ) : (
                          <div className={styles.counterText}>
                            {rbCaraBayar !== 'VA' ? (
                              <p className='col-12'>
                                Terima Kasih pembayaran Anda telah kami terima
                              </p>
                            ) : null}
                          </div>
                        )}
                        <div className={styles.flexcnter}>
                          <Row>
                            <Col className='col-6'>
                              <div
                                className={
                                  !statusPaymentOnline && !isPayment
                                    ? styles.buttonnextDisable
                                    : styles.buttonnext
                                }
                              >
                                <button
                                  style={{
                                    textDecoration: 'none',
                                    color: 'white'
                                  }}
                                  disabled={!statusPaymentOnline && !isPayment}
                                  onClick={async () =>{

                                    await checkNextStep(
                                      SPAJs,
                                      SPAJDetail,
                                      DeviceId,
                                      rbCaraBayar,
                                      setVisiblePopupVa,
                                      paymentData,
                                      responsePayment,
                                      rbCaraBayar1,
                                      vaAccount,
                                      dispatch,
                                      navigate,
                                      isPayment,
                                      setWordingModal,
                                      setShowPopupLengkapi,
                                      setLoading,
                                      vaAccountBni,
                                      vaAccountBri,
                                      vaAccountMandiri,
                                      vaBank
                                    )
                                  }
                                  }
                                >
                                  Kirim SPAJ
                                </button>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <Modal
                      dialogClassName={styles.modalcustom}
                      centered
                      show={visiblePopupVa}
                    >
                      <Modal.Body>
                        <div className='mt-40'>
                          <p className='fs-22center'>
                            Dengan Ini Anda Menyetujui Perubahan Pembayaran
                            Online Anda Menjadi Virtual Account?
                          </p>
                          <div className='btnmodal'>
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'flex-end'
                              }}
                            >
                              <div
                                className={styles.buttonkembalimodal}
                                onClick={() =>
                                  lanjutPembayaran(
                                    SPAJs,
                                    SPAJDetail,
                                    DeviceId,
                                    rbCaraBayar,
                                    setVisiblePopupVa,
                                    paymentData,
                                    responsePayment,
                                    rbCaraBayar1,
                                    vaAccount,
                                    dispatch,
                                    navigate,
                                    setWordingModal,
                                    setShowPopupLengkapi,
                                    setLoading,
                                    vaAccountBni,
                                    vaAccountBri,
                                    vaAccountMandiri,
                                    vaBank,
                                  )
                                }
                              >
                                <button>Ya</button>
                              </div>
                              <div
                                className={styles.buttonnextmodal}
                                onClick={() => hidePopup(setVisiblePopupVa)}
                              >
                                <button>Tidak</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Modal.Body>
                    </Modal>

                    <div>
                      <Modal
                        dialogClassName={styles.modalcustom}
                        centered
                        show={visiblePopupPayment}
                      >
                        <Modal.Body>
                          <div className={styles.containerModal}>
                            <p className='fs-15 text-center mb-25'>
                              Pembayaran Berhasil
                            </p>
                            <div
                              onClick={() =>
                                hidePopupPayment(setVisiblePopupPayment)
                              }
                            >
                              <button className={styles.buttonnextmodal}>
                                OK
                              </button>
                            </div>
                          </div>
                        </Modal.Body>
                      </Modal>
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.linkFooter}>
                <div>www.generali.co.id</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Pembayaran